import { render } from "./Tank.vue?vue&type=template&id=13264d72&ts=true"
import script from "./Tank.vue?vue&type=script&lang=ts"
export * from "./Tank.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__